<script setup>
import BaseDashboardBanner from './BaseDashboardBanner.vue'
</script>

<template>
  <BaseDashboardBanner
    buttonText="Play Now"
    buttonLink="https://play.gtowizard.com/?utm_source=gtowizard&utm_medium=dashboard&utm_campaign=poker_arena&utm_content=banner"
  >
    <template #background>
      <div class="poker_arena_inner_back" />
    </template>
    <template #content>
      <div
        class="d-flex f-column"
        style="line-height: 4rem"
      >
        <span style="font-size: 2.05rem; font-weight: 600"
          ><span class="clr-primary">Play Mode is now PokerArena </span></span
        >
        <span
          class="weight_400"
          style="font-size: 1.27rem; font-weight: 400; color: #fdfdfd; line-height: 2.05rem"
          >And July kicks off Season One. Monthly format,<br />
          rewards, iOS app and more…</span
        >
      </div>
    </template>
  </BaseDashboardBanner>
</template>

<style lang="scss" scoped>
.poker_arena_inner_back {
  z-index: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0%;
  z-index: -1;
  background: url('@/assets/img/app_banner_poker_arena.webp');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
}
</style>
